<template>
  <div class="block">
    <header>
      <div class="back" @click="backToHome">返回上一页</div>
    </header>
    <el-form ref="formRef" label-width="40px" :inline="true">
      <el-form-item class="block-form-item" label="标题" :inline="false">
        <el-input
          v-model="title"
          placeholder="文章标题"
          maxlength="30"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="分类">
        <el-select v-model="classfy" clearable>
          <el-option
            v-for="item in classfyOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label-width="280px"
        label="关联地图（会出现在相关地图的详情页上）"
      >
        <el-select v-model="relativeMapId" clearable>
          <el-option
            v-for="item in MapOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label-width="440px"
        label="动态ID（在迷你世界内分享动态时，点击右下角的数据ID即可复制）"
        size="normal"
      >
        <el-input v-model="trendId" placeholder="动态ID" show-word-limit />
      </el-form-item>
    </el-form>
    <div class="deployBtn">
      <el-button type="primary" @click="publishArticle">确定</el-button>
    </div>
  </div>
</template>
<script>
import { actConfApi } from '../../../api/actConf';
import { CLASSFY } from './CONST';
const { trendRelated, updateTrendRelated, getTrendRelatedInfo } = actConfApi;
export default {
  data() {
    return {
      id: 0,
      trendId: 0,
      title: '',
      relativeMapId: '',
      MapOptions: [],
      articleCont: '',
      classfy: 0,
      classfyOptions: CLASSFY,
      optState: false, // false 新文章 true 编辑文章
    };
  },
  mounted() {
    this.MapOptions = this.getMaps();
    this.id = this.$route.params.id;
    this.optState = !!parseInt(this.id, 10);
    if (this.optState) {
      this.getTrendRelatedInfo();
    }
  },
  methods: {
    publishArticle() {
      if (!this.title) {
        return this.errorTips('请填写文章标题');
      }
      if (!this.trendId) {
        return this.errorTips('请填写动态ID');
      }
      const params = {
        map_id: this.relativeMapId,
        title: this.title,
        posting_id: this.trendId,
        category: this.classfy,
      };
      if (this.optState) {
        params.id = this.id;
        updateTrendRelated(params).then(this.handleArticlePost);
      } else {
        trendRelated(params).then(this.handleArticlePost);
      }
    },
    getTrendRelatedInfo() {
      getTrendRelatedInfo({ id: this.id, json: 1 }).then(res => {
        const { code, data } = res;
        if (code === 0) {
          const { category, title, posting_id, map_id, id } = data;
          this.title = title;
          this.trendId = posting_id;
          this.classfy = category;
          this.relativeMapId = map_id;
          this.id = id;
        }
      });
    },
    handleArticlePost(res) {
      const { code, msg } = res;
      if (code === 0) {
        this.successTips((this.optState ? '更新' : '发布') + '成功');
        setTimeout(() => {
          this.backToHome();
        }, 1000);
      } else {
        return this.errorTips(msg);
      }
    },
    getUserInfo() {
      let userInfo = sessionStorage.getItem('userInfo');
      if (userInfo) {
        if (typeof userInfo === 'string') {
          return JSON.parse(userInfo);
        } else {
          return userInfo;
        }
      }
      return {};
    },
    getStoreKey() {
      const uin = this.getUserInfo().uin || '';
      return 'my_maps_' + uin;
    },
    getMaps() {
      const KEY = this.getStoreKey();
      let maps = localStorage.getItem(KEY);
      let res = [];
      if (typeof maps === 'string') {
        maps = JSON.parse(maps);
      }
      res = maps;
      return res;
    },
    backToHome() {
      this.$router.push({ name: 'actTrendConfList' });
    },
    errorTips(msg) {
      return this.$message ? this.$message.error(msg) : this.$toast.fail(msg);
    },
    successTips(msg) {
      return this.$message ? this.$message.success(msg) : this.$toast(msg);
    },
  },
};
</script>
<style src="../../../style/common-pc.scss" lang="scss" scoped></style>
<style
  src="../../../style/exchange-shop/pc/common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.block {
  .back {
    display: inline-block;
  }
}
.dataTable {
  // border-top: 1px solid #d9d9d9;
  margin: 0 auto 0;
  // padding-top: 32px;
}
.tableHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 27px;
  .tabHeadLeft {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    flex: 1 0 auto;
    h4 {
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #262626;
      line-height: 33px;
      margin-right: 20px;
    }
    span {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 20px;
    }
  }
  .tabHeadRight {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .labelName {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 20px;
      margin-right: 14px;
    }
    .btn-newArticle {
      margin-left: 24px;
    }
  }
}
.block-form-item {
  display: block;
  margin-right: 0;
  ::v-deep .el-form-item__content {
    width: 950px;
  }
}
.deployBtn {
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  ::v-deep .el-button {
    width: 240px;
    font-size: 18px;
  }
}
</style>
